import type { FreeStatus } from '../types';
import { fmtCountdown } from '../lib/format';

interface Props {
  phase:     string;
  free:      FreeStatus;
  errMsg:    string;
  onConnect: () => void;
}

const FreeSection = ({ phase, free, errMsg, onConnect }: Props) => {
  const isChecking = free.status === 'checking';
  const isCooldown = free.status === 'cooldown';
  const busy       = phase === 'busy-free' || phase === 'busy-voucher';

  return (
    <div className="tier">
      <button
        className={`btn${isCooldown ? ' btn-locked' : ''}`}
        type="button"
        disabled={busy || isCooldown || isChecking}
        onClick={onConnect}
      >
        {phase === 'busy-free' ? (
          <span className="spinner" />
        ) : free.status === 'cooldown' ? (
          <>Wartezeit&ensp;<span className="countdown">{fmtCountdown(free.remaining)}</span></>
        ) : (
          'Verbinden'
        )}
      </button>
      <p className="tier-hint">
        {isCooldown
          ? 'Du kannst dich gleich wieder gratis verbinden.'
          : '30 Minuten surfen, danach 15 Minuten Wartezeit'}
      </p>
      {phase === 'err-free' && <p className="err-msg">{errMsg}</p>}
    </div>
  );
};

export default FreeSection;
